<script lang="ts">
	let {
		text,
		loading = false,
		status,
		uiState = $bindable('passive')
	}: {
		text: string;
		loading?: boolean;
		status?: number;
		uiState?: 'passive' | 'success' | 'loading' | 'error';
	} = $props();
	import { Cross, Check, Loading } from '@icons';

	$effect(() => {
		let timeout: number | undefined;
		if (status) {
			if (status >= 200 && status < 400) {
				uiState = 'success';
			} else {
				uiState = 'error';
			}
			timeout = window.setTimeout(() => {
				uiState = 'passive';
			}, 5000);
		} else {
			if (timeout) window.clearTimeout(timeout);
			uiState = loading ? 'loading' : 'passive';
		}
		return () => {
			if (timeout) window.clearTimeout(timeout);
		};
	});
</script>

<button
	type="submit"
	class={`${uiState === 'passive' ? 'button:outline' : 'button:pill'} no-icon`}
	disabled={loading}
>
	<span class:active={uiState === 'passive'}>{text}</span>
	<span class:active={uiState === 'loading'}><Loading /> </span>
	<span class:active={uiState === 'success'}><Check /> </span>
	<span class:active={uiState === 'error'}><Cross /></span>
</button>

<style lang="scss">
	button {
		display: grid;
		justify-items: center;
		align-items: center;
		transition-property: none;
	}

	span {
		grid-row: 1;
		grid-column: 1;
		visibility: hidden;
		display: flex;

		:global(svg) {
			height: 1.2em;
			width: 1.2em;
		}
	}

	.active {
		visibility: visible;
	}
</style>
